import React from 'react'
import FreightMaster from './FreightMaster/FreightMaster'
import LocationMaster from './LocationMaster/LocationMaster'
import TruckMaster from './TruckMaster/TruckMaster'
import VendorMaster from './VendorMaster/VendorMaster'
import OtherMaster from './OtherMaster/OtherMaster'
import RouteMaster from './OtherMaster/RouteMaster/RouteMaster'
import { Route, Switch} from 'react-router-dom';
import Map from './Map/Map'
const MastersRouting = ({ editMode, freightdata, orgList, selectedOrg, canedit, canAccess, canUpdate, checkActionPermission, onViewMap }) => {
  return (
    <>
      <Switch>
        <Route
          path="/companyprofilenew/masters/freightmaster"
          render={() => (!editMode ? <FreightMaster selectedOrg={selectedOrg} canedit={canedit} canAccess={canAccess} canUpdate={canUpdate} checkActionPermission={checkActionPermission} onViewMap={onViewMap} /> : <Map network1={freightdata} />)}
          exact />
        <Route
          path='/companyprofilenew/masters/locationmaster'
          render={() => <LocationMaster canedit={canedit} canAccess={canAccess} canUpdate={canUpdate} checkActionPermission={checkActionPermission} />}
          exact />
        <Route
          path='/companyprofilenew/masters/truckmaster'
          render={() => <TruckMaster canedit={canedit} canAccess={canAccess} canUpdate={canUpdate} checkActionPermission={checkActionPermission} />}
          exact />
        <Route
          path='/companyprofilenew/masters/vendormaster'
          render={() => <VendorMaster canedit={canedit} canAccess={canAccess} canUpdate={canUpdate} checkActionPermission={checkActionPermission} />}
          exact />
        <Route
          path='/companyprofilenew/masters/materialmaster'
          render={() => <OtherMaster canedit={canedit} canAccess={canAccess} canUpdate={canUpdate} checkActionPermission={checkActionPermission} />}
          exact />
        <Route
          path='/companyprofilenew/masters/routemaster'
          render={() => <RouteMaster canedit={canedit} canAccess={canAccess} canUpdate={canUpdate} checkActionPermission={checkActionPermission} />}
          exact />
      </Switch>
    </>
  )
}

export default MastersRouting